<template>
  <div>
    <Top v-if="$route.name != 'userCenter'" />
    <!-- 路由匹配到的组件将渲染在这里 -->
    <!-- <keep-alive> -->
    <router-view :class="{ appbox: true, haveTab: $route.meta.showTab }"></router-view>
    <!-- </keep-alive> -->
    <tab-bar v-if="$route.meta.showTab"></tab-bar>
  </div>
</template>

<script>
import Top from '@/components/top'
import tabBar from '@/components/tabbar'
export default {
  name: 'App',
  components: { tabBar, Top },
  data() {
    return {
      showtab: false,
      heightChange: true,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
    }
  },
  created() {},
  mounted() {
    window.onresize = () =>
      (() => {
        this.showHeight = document.body.clientHeight
      })()
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.heightChange = false
      } else {
        this.heightChange = true
      }
    },
    //   $route(val) {
    //     console.log(val)
    //     this.showtab = val.meta.showTab
    //   },
  },
}
</script>

<style lang="scss">
.appbox {
  height: calc(100vh - 50px);
  padding: 0 16px 10px;
  overflow-y: auto;
  &.haveTab {
    height: calc(100vh - 120px);
  }
}
</style>
